/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef } from "react";
import { EmailTemplateModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import EmailTemplate from "./EmailTemplate";

type EmailTemplateModalProps = {
  open: boolean;
  editEmailTemplate: any;
  onClose: () => void;
  addOrUpdateEmailTemplate: (emailTemplate: EmailTemplateModel | null) => void;
};

export default function EmailTemplateModal(props: EmailTemplateModalProps) {
  const { editEmailTemplate, onClose, open, addOrUpdateEmailTemplate } = props;
  const emailTemplateRef = useRef<any>(null);
  return (
    <AddOrUpdateModel
      open={open}
      title={Vocabulary.emailTemplate}
      onClose={onClose}
      isSubmit={true}
      addOrUpdateItem={() => null}
      handleChangePressOnSubmit={()=>{
        emailTemplateRef?.current.handleChangePressOnSubmit();
      }}
    >
      <EmailTemplate
        forRef={emailTemplateRef}
        editEmailTemplate={editEmailTemplate}
        addOrUpdateEmailTemplate={addOrUpdateEmailTemplate}
      />
    </AddOrUpdateModel>
  );
}
